import sv from './sv.json';
import en from './en.json';

export const defaultLocale = 'sv';
export const languages = {
  sv: sv,
  en: en,
};
